import React from 'react';
import PropTypes from 'prop-types';
import { FormShell } from './FormShell';
import './StatusCard.css';

/**
 * Centered status / verification card (email verify, org invite, etc.).
 * tone: muted | error | success for body copy.
 */
export function StatusCard({
  children,
  title,
  tone = 'muted',
  className = '',
  ...props
}) {
  return (
    <div
      className={['onyx-status-card', className].filter(Boolean).join(' ')}
      data-testid="onyx-status-card"
      data-tone={tone}
    >
      <FormShell className="onyx-status-card__shell" {...props}>
        {title ? <h2 className="content__title">{title}</h2> : null}
        <div className={`onyx-status-card__body onyx-status-card__body--${tone}`}>
          {children}
        </div>
      </FormShell>
    </div>
  );
}

StatusCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  tone: PropTypes.oneOf(['muted', 'error', 'success']),
  className: PropTypes.string,
};

export default StatusCard;
